import type { FlightScheduleChange, FlightScheduleChangeAirline, FlightScheduleChangeEndpoints, FlightScheduleChangeFlight, FlightScheduleChangeHiddenStop, FlightScheduleChangeLeg } from 'api/flightScheduleChanges.types'

function endpointsMap(value: FlightScheduleChangeEndpoints) {
  return {
    departureDateTime: value.departureDateTime,
    arrivalDateTime: value.arrivalDateTime,
    departureAirport: value.departureAirport ?? undefined,
    departureCity: value.departureCity ?? undefined,
    departureCountry: value.departureCountry ?? undefined,
    departureTimezone: value.departureTimezone ?? undefined,
    arrivalAirport: value.arrivalAirport ?? undefined,
    arrivalCity: value.arrivalCity ?? undefined,
    arrivalCountry: value.arrivalCountry ?? undefined,
    arrivalTimezone: value.arrivalTimezone ?? undefined,
  }
}

function airlineMap(value: FlightScheduleChangeAirline): App.FlightScheduleChangeAirline {
  return {
    ...value,
    code: value.code ?? undefined,
    name: value.name ?? undefined,
    logoUrl: value.logoUrl ?? undefined,
  }
}

function hiddenStopMap(value: FlightScheduleChangeHiddenStop): App.FlightScheduleChangeHiddenStop {
  return {
    ...value,
    airportCode: value.airportCode ?? undefined,
    arrivalDate: value.arrivalDate ?? undefined,
    arrivalTime: value.arrivalTime ?? undefined,
    departureDate: value.departureDate ?? undefined,
    departureTime: value.departureTime ?? undefined,
    aircraftType: value.aircraftType ?? undefined,
    aircraftTypeCode: value.aircraftTypeCode ?? undefined,
  }
}

function flightMap(value: FlightScheduleChangeFlight): App.FlightScheduleChangeFlight {
  return {
    ...value,
    ...endpointsMap(value),
    marketingAirline: airlineMap(value.marketingAirline),
    operatingAirline: airlineMap(value.operatingAirline),
    hiddenStops: value.hiddenStops.map(hiddenStopMap),
    id: value.id ?? undefined,
    status: value.status ?? undefined,
    statusCode: value.statusCode ?? undefined,
    flightNumber: value.flightNumber ?? undefined,
    departureAirportName: value.departureAirportName ?? undefined,
    departingDate: value.departingDate ?? undefined,
    departingTime: value.departingTime ?? undefined,
    departureTerminal: value.departureTerminal ?? undefined,
    arrivalAirportName: value.arrivalAirportName ?? undefined,
    arrivalDate: value.arrivalDate ?? undefined,
    arrivalTime: value.arrivalTime ?? undefined,
    arrivalTerminal: value.arrivalTerminal ?? undefined,
    aircraftType: value.aircraftType ?? undefined,
    cabinClass: value.cabinClass ?? undefined,
  }
}

function legMap(value: FlightScheduleChangeLeg): App.FlightScheduleChangeLeg {
  return {
    ...value,
    ...endpointsMap(value),
    flights: value.flights.map(flightMap),
  }
}

export function flightScheduleChangeMap(change: FlightScheduleChange): App.FlightScheduleChange
export function flightScheduleChangeMap(change?: FlightScheduleChange | null): App.FlightScheduleChange | undefined
export function flightScheduleChangeMap(change?: FlightScheduleChange | null): App.FlightScheduleChange | undefined {
  if (!change) return undefined

  return {
    ...change,
    respondBy: change.respondBy ?? undefined,
    oldLegs: change.oldLegs.map(legMap),
    newLegs: change.newLegs.map(legMap),
  }
}
